export enum WorkshopAttendanceStatus {
  REGISTERED = 'angemeldet',
  ATTENDED = 'teilgenommen',
  CANCELLED = 'abgesagt',
  NO_SHOW = 'nicht erschienen',
}
